<template>
    <div id="registered-at-manager">
        <v-card ref="registeredAtManager">
            <v-card-title>Registered At Manager
                <v-spacer></v-spacer>
                <registered-at-add v-if="getAccess()" @refreshData="refreshData" @setNotification="setNotification">
                </registered-at-add>
            </v-card-title>
            <v-card-text>
                <v-data-table :headers="headers" :items="data" sort-by="location">
                    <template v-if="getAccess()" v-slot:item.actions="{ item }">
                        <registered-at-edit :item="item" @refreshData="refreshData" @setNotification="setNotification">
                        </registered-at-edit>
                        <registered-at-delete :item="item" @refreshData="refreshData"
                            @setNotification="setNotification">
                        </registered-at-delete>
                    </template>
                    <template v-slot:item.getDefault="{ item }">
                        <v-chip :color="getDefaultColor(item)" small>
                            {{ getDefaultLabel(item) }}
                        </v-chip>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import RegisteredAtAdd from './AddRegisteredAt';
import RegisteredAtDelete from './DeleteRegisteredAt';
import RegisteredAtEdit from './EditRegisteredAt';

export default {
    name: 'registered-at-manager',
    components: {
        RegisteredAtAdd,
        RegisteredAtDelete,
        RegisteredAtEdit
    },
    props: {
        data: {
            required: true,
            type: Array
        },
        permission: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            headers: [{
                    align: 'start',
                    text: 'Location',
                    value: 'location'
                },
                {
                    text: 'Created Date',
                    value: 'datecode',
                },
                {
                    text: 'Created By',
                    value: 'createdByUsername',
                },
                {
                    sortable: false,
                    text: 'Default',
                    value: 'getDefault',
                },
                {
                    sortable: false,
                    text: 'Actions',
                    value: 'actions'
                }
            ]
        }
    },
    methods: {
        getAccess() {
            if (this.permission.enabled == "1" && this.permission.access == "write") {
                return true;
            }

            return false;
        },
        getDefaultColor(item) {
            if (item.default && item.default == "1") {
                return '#1dc9b7';
            }

            return '#f64e60';
        },
        getDefaultLabel(item) {
            if (item.default && item.default == "1") {
                return 'Yes';
            }

            return 'No';
        },
        refreshData() {
            this.$emit('refreshData');
        },
        setNotification(color, icon, message, status) {
            this.$emit('setNotification', color, icon, message, status);
        }
    }
}
</script>